import { render, staticRenderFns } from "./stepsHeader.vue?vue&type=template&id=49d812b3&scoped=true&"
import script from "./stepsHeader.vue?vue&type=script&lang=js&"
export * from "./stepsHeader.vue?vue&type=script&lang=js&"
import style0 from "./stepsHeader.vue?vue&type=style&index=0&id=49d812b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d812b3",
  null
  
)

export default component.exports